import { IExclusivityAvailabilityState } from "@faire/web-api--source/faire/exclusivity_agreement/client/IExclusivityAvailabilityState";
var State = IExclusivityAvailabilityState.State;
export var getStateInfoFromAvailability = function(status) {
    if (!(status === null || status === void 0 ? void 0 : status.state)) {
        return {
            isActivated: false,
            isAvailable: false,
            isRequested: false,
            isBlocked: false,
            isUnsettledAgreement: false,
            isNotEnabled: false,
            isNotActivatedOrAvailable: false,
            isZipCodeBlocked: false,
            isUnknown: true
        };
    }
    var isRequested = status.state === State.REQUESTED;
    var isActivated = ACTIVATED_STATES.includes(status.state);
    var isAvailable = AVAILABLE_STATES.includes(status.state);
    var isBlocked = BLOCKED_STATES.includes(status.state);
    var isUnsettledAgreement = UNSETTLED_AGREEMENT_STATES.includes(status.state);
    var isUnknown = status.state === State.STATE_UNKNOWN;
    var isNotEnabled = NOT_ENABLED_STATES.includes(status.state);
    var isZipCodeBlocked = status.state === State.ZIPCODE_BLOCKED;
    return {
        isActivated: isActivated,
        isAvailable: isAvailable,
        isBlocked: isBlocked,
        isRequested: isRequested,
        isUnsettledAgreement: isUnsettledAgreement,
        isUnknown: isUnknown,
        isNotEnabled: isNotEnabled,
        isZipCodeBlocked: isZipCodeBlocked,
        isNotActivatedOrAvailable: !(isActivated || isAvailable)
    };
};
export var ACTIVATED_STATES = [
    State.ACTIVE,
    State.PENDING
];
export var AVAILABLE_STATES = [
    State.AVAILABLE
];
var NOT_ENABLED_STATES = [
    State.NOT_ENABLED
];
var BLOCKED_STATES = [
    State.BLOCKED
];
var UNSETTLED_AGREEMENT_STATES = [
    State.UNSETTLED_AGREEMENT
];
